import axios from '@/lib/AxApi';

export default {
    async selectDocuments(params)
    {
        try
        {
            const response = await axios.get('/ChildDocumentsKindergarten/selectDocuments',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async insertDocument(params)
    {
        try
        {
            const response = await axios.post('/ChildDocumentsKindergarten/insertDocument', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/ChildDocumentsKindergarten/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
};
